import { render } from "./FloatLabelDemo.vue?vue&type=template&id=a5aed5fc"
import script from "./FloatLabelDemo.vue?vue&type=script&lang=js"
export * from "./FloatLabelDemo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__